module.exports = __webpack_public_path__ + "img/cbe5e4c.jpg";